<template lang="pug">
  .datepicker.inline(v-on-away="away")
    .dropdown(
      v-if="exclude.indexOf('day') === -1"
      :class="{ 'is-active': activeDay, 'selected': date.day }"
      @click="disabled || date.year === 0 ? false : activeDay = !activeDay")
      .dropdown-trigger
        button.button(:disabled="disabled || date.year === 0")
          span {{ date.day || gettext('Day') }}
      .dropdown-menu(role="menu")
        .dropdown-content
          a.dropdown-item(v-for="day in days" @click="setDay(day)")
            | {{ day }}
    .dropdown(
      v-if="exclude.indexOf('month') === -1"
      :class="{ 'is-active': activeMonth, 'selected': date.month.value }"
      @click="disabled || date.year === 0 ? false : activeMonth = !activeMonth")
      .dropdown-trigger
        button.button(:disabled="disabled || date.year === 0")
          span {{ date.month.short || gettext('Month') }}
      .dropdown-menu(role="menu")
        .dropdown-content
          a.dropdown-item(v-for="(month) in months" @click="setMonth(month)")
            | {{ month.name }}
    .dropdown(
      v-if="exclude.indexOf('year') === -1"
      :class="{ 'is-active': activeYear, 'selected': date.year }"
      @click="activeYear = !activeYear")
      .dropdown-trigger
        button.button(:disabled="disabled")
          span(v-if="date.year === 0") {{ gettext('Present') }}
          span(v-else) {{ date.year || gettext('Year') }}
      .dropdown-menu(role="menu")
        .dropdown-content
          a.dropdown-item(v-if="present" @click="setPresent") {{ gettext('Present') }}
          a.dropdown-item(v-for="year in years" @click="setYear(year)")
            | {{ year }}
    .clear-date(@click="clearDate" v-if="clearButton")
      .mdi.mdi-window-close
</template>

<script>
import {gettext} from '@/services/TranslateHandler'
import { directive as onAway } from 'vue-clickaway'
const _ = require('lodash')

export default {
  name: 'DatePicker',
  directives: {
    onAway
  },
  data () {
    return {
      activeDay: false,
      activeMonth: false,
      activeYear: false,
      date: {
        day: '',
        month: {
          name: '',
          value: ''
        },
        year: ''
      }
    }
  },
  props: {
    maxAge: {
      default: 100
    },
    minAge: {
      default: 16
    },
    offset: {
      default: 0
    },
    sort: {
      default: 'desc'
    },
    value: {
      default: ''
    },
    disabled: {
      default: false
    },
    exclude: {
      default: () => []
    },
    iso: {
      default: false
    },
    clearButton: {
      default: false
    },
    present: {
      default: false
    }
  },
  methods: {
    gettext: gettext,
    setPresent () {
      this.date.day = ''
      this.date.month = {
        name: '',
        value: ''
      }
      this.date.year = 0
    },
    setDay (day) {
      this.date.day = day
    },
    setMonth (month) {
      this.date.month = month
    },
    setYear (year) {
      this.date.year = year
    },
    setData (date) {
      let parsedDate = date.substr('-') ? date.split('-') : [date]
      if (parsedDate.length === 1) {
        let accept = (_.filter(Object.keys(this.date), item => this.exclude.indexOf(item) === -1))[0]
        if (accept === 'month') {
          this.date[accept] = _.find(this.months, {'value': parseInt(parsedDate[0])})
        } else {
          this.date[accept] = parsedDate[0]
        }
      } else {
        this.date.year = parsedDate[0]
        this.date.month = _.find(this.months, {'value': parseInt(parsedDate[1])})
        this.date.day = parseInt(parsedDate[2])
      }
    },
    clearDate () {
      this.date = {
        day: '',
        month: {
          name: '',
          value: ''
        },
        year: ''
      }
      this.$emit('input', '')
    },
    away () {
      this.activeDay = false
      this.activeMonth = false
      this.activeYear = false
    }
  },
  computed: {
    days: function () {
      const N = 31
      return Array.from({length: N}, (value, key) => key + 1)
    },
    months: function () {
      return [
        {name: gettext('January'), value: 1, short: gettext('Jan.')},
        {name: gettext('February'), value: 2, short: gettext('Feb.')},
        {name: gettext('March'), value: 3, short: gettext('Mar.')},
        {name: gettext('April'), value: 4, short: gettext('Apr.')},
        {name: gettext('May'), value: 5, short: gettext('May')},
        {name: gettext('June'), value: 6, short: gettext('Jun.')},
        {name: gettext('July'), value: 7, short: gettext('Jul.')},
        {name: gettext('August'), value: 8, short: gettext('Aug.')},
        {name: gettext('September'), value: 9, short: gettext('Sep.')},
        {name: gettext('October'), value: 10, short: gettext('Oct.')},
        {name: gettext('November'), value: 11, short: gettext('Nov.')},
        {name: gettext('December'), value: 12, short: gettext('Dec.')}
      ]
    },
    years: function () {
      let result = Array.from({length: this.maxAge}, (value, key) => key + (this.startDate - ((this.maxAge - 1) + this.minAge)))
      return this.sort === 'asc' ? result : result.reverse()
    },
    validation: function () {
      if (this.date.day && this.date.month.value && this.date.year) {
        return true
      } else if (this.exclude.length > 0) {
        let result = 1
        for (let item in this.date) {
          if (this.exclude.indexOf(item) === -1) {
            result *= this.date[item].value || this.date[item]
          }
        }
        return !!(result)
      }
      return false
    },
    startDate: function () {
      return (new Date()).getFullYear() + this.offset
    }
  },
  watch: {
    validation: function (val) {
      this.$emit('valid', val)
    },
    date: {
      handler: function () {
        this.$emit('valid', this.validation)
        if (this.date.year === 0) {
          this.$emit('input', 0)
        } else if (this.validation) {
          let date = `${this.date.year}-${this.date.month.value}-${this.date.day || 1}`
          if (!this.iso) date = date.replace(/-?$/, '').replace(/^-?/, '')
          this.$emit('input', date)
        }
      },
      deep: true
    },
    value: function (val) {
      if (val) {
        this.setData(val)
      }
      if (this.value === null && this.present) {
        this.setPresent()
      }
    }
  },
  mounted () {
    if (this.value) {
      this.setData(this.value)
    }
    if (this.iso) {
      this.setDay(1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .datepicker {
    .clear-date {
      padding-top: 14px;
      background-color: #eaeaea;
      &:hover {
        background-color: #dfdfdf;
        cursor: pointer;
      }
    }
    border: 1px solid transparent;
    &.is-danger {
      border: 1px solid red;
    }
    display: flex;
    .dropdown {
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 0;
      box-shadow: none;
      color: #414042;
      font-size: 14px;
      font-weight: 600;
      line-height: 26px;
      letter-spacing: 0.14px;
      padding-top: 0;
      padding-bottom: 0;
      position: relative;
      &:after, &:before {
        content: '';
        position: absolute;
        right: 10px;
        top: 12px;
        border: 3.5px solid transparent;
        border-bottom: 6px solid #c7c7c7;
        z-index: 2;
      }
      &:after {
        border-top: 6px solid #c7c7c7;
        border-bottom: none;
        top: 29px;
      }
      .dropdown-trigger {
        width: 100%;
        button {
          width: 100%;
          border-left: 1px solid #c7c7c7;
        }
      }
      .dropdown-menu {
        width: 100%;
        padding-top: 0;
        min-width: 1rem;
        .dropdown-content {
          overflow-y: auto;
          overflow-x: hidden;
          max-height: 300px;
          padding: 0;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          .dropdown-item {
            padding: 0 .4rem;
          }
        }
      }
    }
    :nth-child(2).dropdown {
      border-right: 1px solid #c7c7c7;
      border-left: 1px solid #c7c7c7;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/datepicker/index.vue